import withInjectedProps from 'Components/Core/InjectedPropsContext/withInjectedProps';
import deepEquals from 'Lib/Object/deepEquals';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { actions } from '../../../Data/ReduxViewModels/Equipment';
import { Field } from '../../Core';
import { IFieldProps } from '../../Core/Field/types';
import { getEquipmentMessages } from '../../Worksheets/Core/Helpers/messageHelpers';
import { IStandaloneEquipmentDropdownProps, StandaloneEquipmentDropdown } from './StandaloneEquipmentDropdown';

let idCounter: number = 0;

/**
 * A field wrapper for StandaloneEquipmentDropdown that handles the fetching of required equipment data.
 * This is fetched at the field level so that we can populate the messages collection.
 *
 * Equipment is stored in app state under a specific id.
 *
 * TODO: Currently we can only fetch equipment models with their current calibration status. *
 */
let StandaloneEquipmentDropdownField: React.FC<
  Omit<IFieldProps, 'input'> & Omit<IStandaloneEquipmentDropdownProps, 'equipment'>
> = ({ id: fixedId, value = null, equipmentType, messages = [], ...otherProps }) => {
  if (!equipmentType)
    throw new Error('Component StandaloneEquipmentDropdownField requires an equipmentType to be specified.');

  const dispatch = useDispatch();

  const [internalId] = useState(`equipment-${idCounter++}`);
  const id = fixedId ?? internalId;
  const initialised = useSelector((state: any) => state.equipment.equipmentData[id]?.initialised);
  const equipment = useSelector((state: any) => state.equipment.equipmentData[id]?.data, deepEquals);

  // Hooks for fetching equipment data
  useEffect(() => {
    if (id)
      return () => {
        dispatch(actions.cleanupEquipmentData({ id }));
      };
  }, [dispatch, id]);
  useEffect(() => {
    if (id) dispatch(actions.initEquipmentData({ id, equipmentId: otherProps.simpleValue ? value : value?.Id }));
  }, [dispatch, id, value, otherProps.simpleValue]);
  useEffect(() => {
    if (initialised && id) dispatch(actions.getEquipmentData({ id }));
  }, [dispatch, id, value, initialised]);

  return (
    <Field
      input={<StandaloneEquipmentDropdown />}
      equipment={equipment}
      id={id}
      equipmentType={equipmentType}
      value={value}
      messages={messages.concat(getEquipmentMessages(equipment))}
      {...otherProps}
    />
  );
};

StandaloneEquipmentDropdownField = withInjectedProps(StandaloneEquipmentDropdownField);

export { StandaloneEquipmentDropdownField };
